import { Box, Grid, MenuItem, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import {
  RootState,
  useAppDispatch,
} from "../../../../app/features/store/store";
import FormikTextField from "../../../../components/common/formikFields/FormikTextField";
import SubmitModalWithFormik from "../../../../components/common/modalPopup/SubmitModalWithFormik";
import {
  LATE_CANCELLATION_TYPES,
  VARIABLE_RATE_TYPES,
} from "../RateCardConstants";
import { toast } from "react-toastify";
import { DateObject } from "react-multi-date-picker";
import { RatecardResponse } from "../dtos/RateCardResponse";
import getAxiosError from "../../../../app/api/axiosError";
import { mapValuesUiRequestToUpdateRatecardValue } from "../utils/RatecardUtils";
import { mapValuesUiRequestToUpdateCustomFields } from "../utils/CustomFieldsUtills";
import { mapValuesUiRequestToUpdatePeakSurcharge } from "../utils/PeakSurchargeUtils";
import { getRouteRateValidationSchema } from "../RatecardValidations";
import {
  UpdateFuelSurchargeLookup,
  UpdateFuelSurchargeFields,
  UpdateCustomFields,
} from "../dtos/UpdateRateCardRequest";
import DiscountPremium from "./DiscountPremium";
import PeakSurcharge from "./PeakSurcharge";
import FuelSurcharge from "./FuelSurcharge";
import { addNewRatecard } from "../../../../app/features/ratecard/ratecardSlice";
import Loader from "../../../../components/common/loader/Loader";
import { AddRateCardRequest } from "../dtos/AddRateCardRequest";
import { mapSnakeCaseToCapitalCaseWithSpaces } from "../../../../components/common/utils/StringUtils";
import CustomFields from "./CustomFields";
import { mapValuesUiRequestToUpdateFuelSurchargeFields } from "../utils/FuelSurchargeUtils";
// type to recieve parameter for this component to initialize
interface AddRouteRateModalProps {
  clientId: number;
  ratecardData: RatecardResponse | null;
  ratecardRequest: AddRateCardRequest;
  closeAddRouteRateModal: CallableFunction;
  onCompleted: CallableFunction;
}
export interface UpdatePeakSurchargeUIRequest {
  peakSurchargeId?: number;
  peakSurchargeType: string | null;
  peak_surcharge_date_range: DateObject[];
  peak_surcharge_value_percentage: number | undefined;
  peak_surcharge_value_dollar: number | undefined;
}

export interface UpdateRouteRateUIRequest {
  values_id?: number;
  baseRate: number | undefined;
  variableRate: number | undefined;
  variableRateType: string;
  routeMinimum: number | undefined;
  lateCancellationCharge: number | undefined;
  lateCancellationType: string;
  fuelType?: string;
  regionName?: string;
  
  //discount
  discountType?: string;
  discountMinVolumeRate?: number;
  discountFrequency?: string;
  discountUnitType?: string;
  discountValue?: number;
  // extra fields for the UI
  // show_discount?: any[];
  show_discount: boolean;
  discount_type?: string;
  discount_volume_min_unit?: number;
  discount_volume_frequency?: string;
  discount_volume_unit_type: string | null;
  discount_volume_value_percentage?: number;
  discount_volume_value_dollar?: number;
  discount_rate_type?: string;
  discount_rate_min_unit?: number;
  discount_rate_frequency?: string;
  discount_rate_unit_type: string | null;
  discount_rate_value_percentage?: number;
  discount_rate_value_dollar?: number;
  // FUEL SURCHARGE
  show_fuel_surcharge: boolean;
  show_custom_fields: boolean;
  fuelSurchargeFields: UpdateFuelSurchargeFields[];
  fuelSurchargeLookup: UpdateFuelSurchargeLookup[];
  lookup_file_upload: boolean;

  rateCardCustomFieldsData:UpdateCustomFields[];
  //peak surcharge
  show_peak_surcharge: boolean;
  peakSurcharge: UpdatePeakSurchargeUIRequest[];
}

// Update route rate modal component
const AddRouteRateModal = (props: AddRouteRateModalProps) => {
  // data to keep in store
  const dispatch = useAppDispatch();

  const { authResponse } = useSelector((state: RootState) => state.login);

  const initialValues: UpdateRouteRateUIRequest = {
    // VALUES
    values_id: undefined,
    baseRate: undefined,
    variableRate: undefined,
    routeMinimum: undefined,
    lateCancellationCharge: undefined,
    variableRateType: "package",
    lateCancellationType: "per_route",
    fuelType: "",
    regionName: "",
    discountType: undefined,
    discountMinVolumeRate: undefined,
    discountFrequency: "",
    discountUnitType: undefined,
    discountValue: undefined,
    // discount - UI parameters
    show_discount: false,
    discount_type: "volume",
    // discount - UI parameters - volume
    discount_volume_min_unit: undefined,
    discount_volume_frequency: "",
    discount_volume_unit_type: null,
    discount_volume_value_percentage: undefined,
    discount_volume_value_dollar: undefined,
    // discount - UI parameters - rate
    discount_rate_type: "base_rate",
    discount_rate_frequency: "",
    discount_rate_min_unit: undefined,
    discount_rate_unit_type: null,
    discount_rate_value_percentage: undefined,
    discount_rate_value_dollar: undefined,
    rateCardCustomFieldsData: [],
    // FUEL SURCHARGE
    show_fuel_surcharge: false,
    show_custom_fields:false,
    fuelSurchargeFields: [],
    fuelSurchargeLookup: [],
    lookup_file_upload: false,
    // CUSTOM FIELDS
   
    // PEAK SURCHCARGE
    show_peak_surcharge: false,
    peakSurcharge: [],
  };


  const handleSubmit = async (
    addRatecardValuesUIRequest: UpdateRouteRateUIRequest,
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    try {
      const updateRateCardValues = mapValuesUiRequestToUpdateRatecardValue(
        addRatecardValuesUIRequest
      );

      const updateRateCardFuelSurchargeFields =
        mapValuesUiRequestToUpdateFuelSurchargeFields(
          addRatecardValuesUIRequest,
          authResponse?.userSettings?.userName
        );

      const updateCustomFields =mapValuesUiRequestToUpdateCustomFields(addRatecardValuesUIRequest);


      const updateRateCardFuelSurchargeLookup =
        addRatecardValuesUIRequest.lookup_file_upload &&
        addRatecardValuesUIRequest.fuelSurchargeLookup.length > 0
          ? addRatecardValuesUIRequest.fuelSurchargeLookup
          : [];

      const updateRateCardPeakSurcharge =
        mapValuesUiRequestToUpdatePeakSurcharge(addRatecardValuesUIRequest);

      const addRatecardRequest: AddRateCardRequest = {
        ratecardName: props.ratecardRequest.ratecardName,
        ratecardType: props.ratecardRequest.ratecardType,
        ratecardClientMappings: props.ratecardRequest.ratecardClientMappings,
        ratecardValues: updateRateCardValues,
        ratecardFuelSurchargeFields: updateRateCardFuelSurchargeFields,
        ratecardFuelSurchargeLookup: updateRateCardFuelSurchargeLookup,
        rateCardCustomFieldsData:updateCustomFields,
        ratecardPeakSurcharges: updateRateCardPeakSurcharge,
        createdBy: authResponse?.userSettings?.userName ?? "",
        updatedBy: authResponse?.userSettings?.userName ?? "",
      };

      console.log("Add Rate Card Request", addRatecardRequest);

      const response = await dispatch(
        addNewRatecard({
          clientId: props.clientId,
          ratecardData: addRatecardRequest,
        })
      ).unwrap();
      if (!response.isSuccess) {
        toast.error(response.message, {
          toastId: "addRatecard",
        });
        toast.success("Ratecard has been added successfully.");
      }
    } catch (error) {
      const appError = getAxiosError(error);
      if (appError.code === "400") {
        toast.error("Some error occured", {
          toastId: "addRatecardException",
        });
      } else {
        toast.error(appError.errorMessage, {
          toastId: "addRatecardException",
        });
      }
    } finally {
      setSubmitting(false);
      props.onCompleted();
    }
    return true;
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={getRouteRateValidationSchema()}
        onSubmit={(values: UpdateRouteRateUIRequest, { setSubmitting }) => {
          setSubmitting(true);
          handleSubmit(values, setSubmitting);
        }}
      >
        {({
          handleChange,
          handleBlur,
          values,
          touched,
          setFieldValue,
          isSubmitting,
        }) => {
          return (
     
            
            
            
            <SubmitModalWithFormik
              title={"Add Route Rate Details"}
              closeSubmitModal={props.closeAddRouteRateModal}
              childErrorMessage={""}
              allowSubmit={false}
              size="lg"
              isLoading={false}
              submitButtonName="Add"
              closeModalAfterSubmit={false}
            >
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Loader isLoading={isSubmitting} />
                <Form>
                  <Grid container rowSpacing={2} columnSpacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Grid container alignItems={"center"} columnSpacing={2}>
                        <Grid item xs={6}>
                          <Typography>Base Rate</Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <FormikTextField
                            margin="normal"
                            id="baseRate"
                            name="baseRate"
                            label=""
                            size="small"
                            type="number"
                            InputProps={{ inputProps: { min: 0 } }}
                            fullWidth
                            variant={"outlined"}
                            required
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Grid container alignItems={"center"} columnSpacing={2}>
                        <Grid item xs={6}>
                          <Typography>Variable Rate</Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <FormikTextField
                            margin="normal"
                            id="variableRate"
                            name="variableRate"
                            label=""
                            type="number"
                            InputProps={{ inputProps: { min: 0 } }}
                            size="small"
                            fullWidth
                            variant={"outlined"}
                            required
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <FormikTextField
                            select
                            margin="normal"
                            id="variableRateType"
                            name="variableRateType"
                            label="Variable Rate Type"
                            size="small"
                            fullWidth
                            variant={"outlined"}
                            required
                          >
                            {VARIABLE_RATE_TYPES.map((state, index) => (
                              <MenuItem key={index} value={state}>
                                {`Per ${state.replace("_", " ")}`}
                              </MenuItem>
                            ))}
                          </FormikTextField>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Grid container alignItems={"center"} columnSpacing={2}>
                        <Grid item xs={6}>
                          <Typography>Route Minimum</Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <FormikTextField
                            margin="normal"
                            id="routeMinimum"
                            name="routeMinimum"
                            label=""
                            size="small"
                            type="number"
                            InputProps={{ inputProps: { min: 0 } }}
                            fullWidth
                            variant={"outlined"}
                            required
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Grid container alignItems={"center"} columnSpacing={2}>
                        <Grid item xs={6}>
                          <Typography>Late Cancellation Charge</Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <FormikTextField
                            margin="normal"
                            id="lateCancellationCharge"
                            name="lateCancellationCharge"
                            label=""
                            size="small"
                            type="number"
                            InputProps={{ inputProps: { min: 0 } }}
                            fullWidth
                            variant={"outlined"}
                            required
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <FormikTextField
                            select
                            margin="normal"
                            id="lateCancellationType"
                            name="lateCancellationType"
                            label="Late Cancellation Type"
                            size="small"
                            fullWidth
                            variant={"outlined"}
                            required
                          >
                            {LATE_CANCELLATION_TYPES.map((type, index) => (
                              <MenuItem key={index} value={type}>
                                {mapSnakeCaseToCapitalCaseWithSpaces(type)}
                              </MenuItem>
                            ))}
                          </FormikTextField>
                        </Grid>
                      </Grid>
                    </Grid>

                      <CustomFields
                      values = {values}
                      touched = {touched}
                      handleChange={handleChange}
                      handleBlur = {handleBlur}
                      setFieldValue={setFieldValue}
                      />

                    {/* Fuel Surcharge */}
                    <FuelSurcharge
                      values={values}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                    />

                    {/* Discount Premium */}
                    <DiscountPremium
                      values={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                    />

                    {/* Peak Surcharge */}
                    <PeakSurcharge
                      values={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                    />
                  </Grid>
                </Form>
              </Box>
            </SubmitModalWithFormik>
          );
        }}
      </Formik>
    </>

    
  );
  
};

export default AddRouteRateModal;
